import { AxiosResponse } from 'axios';
import axios from './AxiosService';
import axiosRequest from './AxiosRequestService';

export default {
  /**
   * Fetches parking zone data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  /**
   * Fetches parking spot data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */

  /**
   * Fetches parking meter data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
 
  /**
   * Fetches parking spots data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  
  /**
   * Fetches parking groups data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */

  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  // fetchEvents(): Promise<AxiosResponse> {
  //   return axios.get('/events');
  // },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchCurrentWeather(): Promise<AxiosResponse> {
    return axios.get('/weatherStations/average');
    // return axios.get('/weatherStations/average');
  },
  /**
   * Fetches settings data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  fetchOpenWeather(): Promise<AxiosResponse> {
    return axios.get('/v1/weather/air');
    // return axios.get('/weatherStations/average');
  },
  /**
   * Fetches pages data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */

  /**
   * Fetches pages data from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  
  /**
   * Fetches cameras from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  // fetchCameras(): Promise<AxiosResponse> {
  //   return axios.get('/cameras');
  // },
  /**
   * Fetches camera images details from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  // fetchCameraImagesData(id: number): Promise<AxiosResponse> {
  //   return axios.get(`/cameras/${id}/images`);
  // },
  /**
   * Fetches traffic from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  // fetchTraffic(): Promise<AxiosResponse> {
  //   return axios.get('/traffic');
  // },
  /**
   * Fetches POI categories from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  // fetchPoiCategories(): Promise<AxiosResponse> {
  //   return axios.get('/poiLayers');
  // },
  /**
   * Fetches POI points from the api
   * and returns an Promise<AxiosResponse> with the result.
   */

  /**
   * Fetches Events by time from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  /**
   * Fetches track start points from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  
  /**
   * Fetches track start points from the api
   * and returns an Promise<AxiosResponse> with the result.
   */
  
  // new API
  fetchSettingsParams(): Promise<AxiosResponse> {
    return axiosRequest.get('/settings/params');
  },
  fetchSettingsMap(): Promise<AxiosResponse> {
    return axiosRequest.get('/settings/map');
  },
  fetchSegmentsConfig(): Promise<AxiosResponse> {
    return axiosRequest.get('/traffic/configuration');
  },
  fetchTraffic(): Promise<AxiosResponse> {
    return axiosRequest.get('/traffic');
  },
  fetchVmsBoards(): Promise<AxiosResponse> {
    return axiosRequest.get('/vms');
  },
  fetchRadarBoards(): Promise<AxiosResponse> {
    const now = new Date().toISOString();
    return axiosRequest.get('/radars/getRadars?date=' + now);
  },
  fetchVmsBoardDetails(id: string): Promise<AxiosResponse> {
    return axiosRequest.get(`/vms/images?id=${id}`);
  },
  fetchCameras(): Promise<AxiosResponse> {
    return axiosRequest.get(`/cameras`);
  },
  fetchCameraImagesData(id: number): Promise<AxiosResponse> {
    return axiosRequest.get(`/cameras/images?id=${id}`);
  },
  fetchPoiCategories(): Promise<AxiosResponse> {
    return axiosRequest.get('/poiLayers');
  },
  fetchPoiPoints(categories: string): Promise<AxiosResponse> {
    return axiosRequest.get(`/poiPoints?layer_id=${categories}`);
  },
  fetchEventsCategories(): Promise<AxiosResponse> {
    return axiosRequest.get('/events/categories');
  },
  fetchEvents(): Promise<AxiosResponse> {
    // return axiosRequest.get('/events?date=2018-06-02T10%3A27%3A31%2B02%3A00');
    return axiosRequest.get('/events');
  },
  fetchEventsByTime(time: string): Promise<AxiosResponse> {
    return axiosRequest.get(`/events?date=${time}`);
  },
  fetchWeatherStations(): Promise<AxiosResponse> {
    return axiosRequest.get('/weatherStations/getWeatherStations');
  },
  fetchWeatherStationsGroups(): Promise<AxiosResponse> {
    return axiosRequest.get('/weatherStations/getWeatherStationsGroups');
  },
  fetchBikeStations(): Promise<AxiosResponse> {
    return axiosRequest.get('/bikeStations');
  },
  fetchParkings(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings');
  },
  fetchParkingGroups(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings/parkingGroups');
  },
  fetchParkingZones(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings/parkingZones');
  },
  fetchParkingSpots(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings/parkingSpots');
  },
  fetchParkingMeters(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings/parkingMeters');
  },
  fetchParkingBoards(): Promise<AxiosResponse> {
    return axiosRequest.get('/parkings/parkingBoards');
  },
  fetchTrackStartPoints(): Promise<AxiosResponse> {
    return axiosRequest.get('/travel/start');
  },
  fetchTrackEndPoints(id: number): Promise<AxiosResponse> {
    return axiosRequest.get(`/travel/end?id_start=${id}`);
  },
  fetchLinks(): Promise<AxiosResponse> {
    return axiosRequest.get('/info/links');
  },
  fetchArticles(): Promise<AxiosResponse> {
    return axiosRequest.get('/info/articles');
  },
};
